export default {
    /**
     * Set the `scrolledPastNav` state
     *
     * @param {Object} context
     * @param {Boolean} val
     */
    scrolledPastNav(context, val) {
        context.scrolledPastNav = val;
    },
};
